var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideSliderArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.293 8.207a1 1 0 001.414 0l6.364-6.364A1 1 0 0013.657.43L8 6.086 2.343.429A1 1 0 00.93 1.843l6.364 6.364zM7 6v1.5h2V6H7z",
    fill: "#150223"
  })));
}
export default SvgHideSliderArrow;